module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('h2', {
    staticClass: "fm_title"
  }, [_vm._v("Glossary")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_6#gloss_1",
      "id": "gloss-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("agoge")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("the Spartan system of raising and educating children.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_7#gloss_2",
      "id": "gloss-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerousia")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("the council of Elders, roughly analogous with a senate.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_7#gloss_3",
      "id": "gloss-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("harmost")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("a military governor of a town or area.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#gloss_4",
      "id": "gloss-4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("helots")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("those bound by the Spartans in a condition between serfdom and slavery.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#gloss_5",
      "id": "gloss-5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("homoi")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("the ‘Equals’ – full Spartan citizens.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_6#gloss_6",
      "id": "gloss-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("kleros")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("land held by a Spartiate to pay for his upkeep.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#gloss_7",
      "id": "gloss-7"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("krypteia")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("Spartan spies and assassins.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_6#gloss_8",
      "id": "gloss-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("mothaces")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("non-Spartiates brought up under the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("agoge")]), _vm._v(" system.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_7#gloss_9",
      "id": "gloss-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("navarchos")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("naval commander.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#gloss_10",
      "id": "gloss-10"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("perioiki")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("non-Spartans living in Laconia and subject to Sparta although nominally independent.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_9#gloss_11",
      "id": "gloss-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("polemarch")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("army or phalanx commander.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_11#gloss_12",
      "id": "gloss-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("rhetra")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("a proposal put to the assembly of the Spartan people.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_11#gloss_13",
      "id": "gloss-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("sarissa")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("a long pike adopted by Philip II of Macedon.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#gloss_14",
      "id": "gloss-14"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spartiates")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("the top rank of Spartan society.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_12#gloss_15",
      "id": "gloss-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("stasis")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("civil strife up to and including civil war.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_3#gloss_16",
      "id": "gloss-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("strategos")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("a general.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_6#gloss_17",
      "id": "gloss-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("syssitia")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("the Spartan military mess. Non-payment of mess fees reduced a Spartiate from that rank.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_9#gloss_18",
      "id": "gloss-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("tresantes")])])]), _vm._v(" "), _c('td', {
    staticClass: "tab"
  }, [_vm._v("‘Tremblers’ – survivors of a losing battle. Again, this title cost a Spartiate his rank.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4008cf66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Glossary.vue
// module id = 72
// module chunks = 0